var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0C7.61758 0 0 7.61758 0 17C0 26.3824 7.61758 34 17 34C26.3824 34 34 26.3824 34 17C34 7.61758 26.3824 0 17 0ZM18.186 19.671V11.4651C18.186 10.8104 17.6547 10.2791 17 10.2791C16.3453 10.2791 15.814 10.8104 15.814 11.4651V19.671L13.366 17.223C12.9026 16.7612 12.1514 16.7612 11.6881 17.223C11.2263 17.6863 11.2263 18.4375 11.6881 18.9008L16.1619 23.373C16.2741 23.4869 16.4054 23.5723 16.5446 23.6308H16.5477C16.6869 23.6893 16.8403 23.7209 17 23.7209C17.1597 23.7209 17.3131 23.6893 17.4523 23.6308H17.4554C17.544 23.5928 17.6278 23.5454 17.7069 23.4869L17.7433 23.46L17.7828 23.4252L17.8223 23.3888L17.8381 23.373L22.3119 18.9008C22.7737 18.4375 22.7737 17.6863 22.3119 17.223C21.8486 16.7612 21.0974 16.7612 20.634 17.223L18.186 19.671Z",
    fill: "#E0AF04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.94dfddcd1619dcdeaad1ec738a808ada.svg";
export { ForwardRef as ReactComponent };